import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=7095af43&scoped=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=ts"
export * from "./TermsOfUse.vue?vue&type=script&lang=ts"
import style0 from "./TermsOfUse.vue?vue&type=style&index=0&id=7095af43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7095af43",
  null
  
)

export default component.exports